// Withdrawal must clear optional receipts synchronously without loading the
// parser used only by the lazy booking feature.
export const BOOKING_RECEIPTS_KEY = 'lw_recruiting_analytics_v1';

export function clearBookingReceipts(): void {
  try { window.localStorage.removeItem(BOOKING_RECEIPTS_KEY); } catch { /* Optional storage. */ }
}
